"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryCardComponent = void 0;

var react_1 = __importDefault(require("react"));

require("./template-3-category-card.css");

var prop_types_1 = __importDefault(require("prop-types"));

function CategoryCardComponent(_ref) {
  var heading = _ref.heading,
      position = _ref.position,
      text = _ref.text,
      border = _ref.border,
      classNames = _ref.classNames,
      icon = _ref.icon;
  return react_1.default.createElement("div", {
    className: "flex ".concat(position === 'vertical' ? 'flex-col' : 'items-center', " trade-card ").concat(border === true && 'trade-card-shadow', " ").concat(classNames === null || classNames === void 0 ? void 0 : classNames.wrapper)
  }, react_1.default.createElement("span", {
    className: "icon-wrapper flex justify-center items-center ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.imgWrapper)
  }, icon || react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-5 w-5 text-blue-700",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, react_1.default.createElement("path", {
    d: "M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z"
  }))), react_1.default.createElement("div", {
    className: "".concat(position === 'vertical' ? '' : 'px-5', " ").concat(classNames === null || classNames === void 0 ? void 0 : classNames.contentWrapper)
  }, react_1.default.createElement("h3", {
    className: "".concat(classNames === null || classNames === void 0 ? void 0 : classNames.heading)
  }, heading), text && react_1.default.createElement("p", {
    className: "".concat(classNames === null || classNames === void 0 ? void 0 : classNames.text)
  }, text)));
}

exports.CategoryCardComponent = CategoryCardComponent;
CategoryCardComponent.propTypes = {
  heading: prop_types_1.default.string,
  position: prop_types_1.default.string,
  text: prop_types_1.default.string,
  border: prop_types_1.default.bool,
  classNames: prop_types_1.default.object
};
CategoryCardComponent.defaultProps = {
  heading: 'Carpet Installation',
  position: 'horizontal',
  text: ''
};